import * as actions from './actionsType';

const initialState = {
  proprties: null,
  balance: null,
  consumption: [],
  additional_widgets: [],
  loading: false,

  userPlans: null,
  subscriptionType: null,

  // subscription
  currentSubscriptionStatus: null,

  successMessage: null,
  errorMessage: null,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.DASHBOARD_START:
    case actions.INITIAL_USER_DASHBOARD_START:
    case actions.USER_SUBSCRIPTION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        proprties: action.proprties,
        balance: action.balance,
        consumption: action.consumption,
        additional_widgets: action.additional_widgets,
      };

    case actions.DASHBOARD_FAILED:
    case actions.INITIAL_USER_DASHBOARD_FAILED:
    case actions.USER_SUBSCRIPTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.errorMsg,
      };

    case actions.USER_PLANS_SUCCESS:
      return {
        ...state,
        userPlans: action.userPlans,
      };

    case actions.USER_PLANS_FAILED:
      return {
        ...state,
        userPlans: null,
        loading: false,
        error: action.errorMsg,
      };

    case actions.INITIAL_USER_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        proprties: action.proprties,
        balance: action.balance,
        consumption: action.consumption,
        additional_widgets: action.additional_widgets,
        userPlans: action.userPlans,
        subscriptionType: action.subscriptionType,
      };

    case actions.USER_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        currentSubscriptionStatus: action.currentSubscriptionStatus,
      };

    case actions.USER_DASHBOARD_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.successMessage,
      };

    case actions.USER_DASHBOARD_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };

    case actions.CLEAR_USER_DASHBOARD_MESSAGE:
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      };

    case actions.USER_PLANS_RESET:
      return initialState;

    default:
      return state;
  }
};

export default dashboardReducer;
